// @ts-ignore
import TRANSLATION_LANGUAGES from '../../../lang/translation-languages.json';
import { getConferenceState } from '../../../react/features/base/conference/functions';
import JitsiMeetJS from '../../../react/features/base/lib-jitsi-meet';
import { showNotification } from '../../../react/features/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../react/features/notifications/constants';
import { sendStatsToKibana } from '../../../wildix/components/analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../../../wildix/components/analytics/kibana/constants';
import { transcriptionLanguagesCopied } from '../transcribing/actions.any';
const BASE_LANG = 'en-US';
export function updateLang(language) {
    return (dispatch, getState) => {
        const state = getState();
        const { conference } = getConferenceState(state);
        // @ts-ignore
        const { isTranscriptionDisabled } = state['wildix/features/transcribing'];
        const { langTranscription } = state['wildix/customStorageSettings'];
        // @ts-ignore
        const { isInternalUser } = state['features/base/config'];
        const languageInStore = state['features/subtitles']._language;
        // Create a new variable to avoid reassigning the function parameter
        let resolvedLanguage = language;
        // Check if the language is `undefined` and set a default value
        if (!resolvedLanguage || resolvedLanguage.includes('undefined')) {
            console.warn('Language input is undefined. Setting default language to "en-US".');
            resolvedLanguage = `translation-languages:${BASE_LANG}`;
        }
        let timer = null;
        const proceedWithLanguageUpdate = () => {
            const [, codeLang = langTranscription] = resolvedLanguage.split(':') ?? ['', BASE_LANG];
            const [firstCodeLang] = codeLang.split('-') ?? [BASE_LANG];
            conference?.setLocalParticipantProperty('transcription_language', codeLang);
            dispatch(transcriptionLanguagesCopied(resolvedLanguage, firstCodeLang.toUpperCase()));
            // @ts-ignore
            const fullNameSelectedLang = TRANSLATION_LANGUAGES[codeLang] ?? 'English';
            dispatch(showNotification({
                titleKey: 'dialog.transcribing',
                descriptionKey: 'xbees.transcriberNotification',
                descriptionArguments: { language: fullNameSelectedLang }
            }, NOTIFICATION_TIMEOUT_TYPE.MEDIUM));
            dispatch(sendStatsToKibana([{
                    isInternalUser,
                    isTranscriptionDisabled,
                    langSelected: codeLang,
                    language: resolvedLanguage,
                    languageInStore,
                    userPreferredLangCustomStore: langTranscription
                }], KIBANA_MESSAGES.TranscriptionEnabledByLang));
            if (timer) {
                clearTimeout(timer);
                timer = null; // Clear the timer when status is ON
            }
        };
        const checkTranscriptionStatus = (startTime) => {
            const transcriptionStatus = conference?.getTranscriptionStatus();
            const { OFF, ON } = JitsiMeetJS.constants.transcriptionStatus;
            const elapsedTime = Date.now() - startTime;
            if (transcriptionStatus === ON) {
                proceedWithLanguageUpdate();
            }
            else if (transcriptionStatus === OFF) {
                if (elapsedTime < 60000) { // Stop checking after 1 minute
                    timer = setTimeout(() => checkTranscriptionStatus(startTime), 2000);
                }
                else if (timer) {
                    clearTimeout(timer);
                    timer = null; // Ensure timer is cleared after 1 minute
                }
            }
        };
        // Start checking transcription status with a timeout mechanism
        const startTime = Date.now();
        checkTranscriptionStatus(startTime);
    };
}
